import React from 'react'
import {
	Drawer,
	Row,
	Space,
	Typography,
	Divider,
	Tag
} from 'antd'
import { CloseOutlined, ClockCircleOutlined } from '@ant-design/icons'

export interface IQrScanInfo {
	from: string | null
	to: string | null
	duration: string | null
	durationValue?: number
}

export interface IFormattedFinish {
	id: number
	date: string
	frequency: string
	qrScans: IQrScanInfo
	errorMessages: string[]
}

export interface IChargedPriceForFlatsItem {
	jobId: number
	address: string
	finishes: IFormattedFinish[]
}

interface SingleJobFinishDrawerProps {
	job: IChargedPriceForFlatsItem | null
	open: boolean
	onClose: () => void
}

const SingleJobFinishDrawer: React.FC<SingleJobFinishDrawerProps> = ({ job, open, onClose }) => {
	if (!job) return null

	return (
		<Drawer
			title={
				<Row justify="space-between" align="middle">
					<Space>
						<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
						<Typography.Text strong>{job.address}</Typography.Text>
					</Space>
				</Row>
			}
			width={800}
			visible={open}
			onClose={onClose}
			closeIcon={null}
		>
			{job.finishes.map((finish) => (
				<div key={`${job.jobId}-${finish.id}`} style={{ marginBottom: 16 }}>
					<Typography.Text type="secondary">
						{finish.date} | {finish.frequency}
					</Typography.Text>

					<Row gutter={16} style={{ marginTop: 8 }}>
						<Space size="large">
							<Tag icon={<ClockCircleOutlined />} color={finish.qrScans.from ? 'green' : 'red'}>
								<strong>Príchod:</strong> {finish.qrScans.from ?? '—'}
							</Tag>
							<Tag icon={<ClockCircleOutlined />} color={finish.qrScans.to ? 'green' : 'red'}>
								<strong>Odchod:</strong> {finish.qrScans.to ?? '—'}
							</Tag>
							<Tag color={finish.qrScans.durationValue !== undefined && finish.qrScans.durationValue < 3 ? 'red' : undefined}>
								<strong>Trvanie:</strong> {finish.qrScans.duration ?? '—'}
							</Tag>
						</Space>
					</Row>

					{finish.errorMessages.length > 0 && (
						<div style={{ marginTop: 8 }}>
							{finish.errorMessages.map((err, idx) => (
								<Typography.Text key={idx} type="danger" style={{ display: 'block' }}>
									{err}
								</Typography.Text>
							))}
						</div>
					)}

					<Divider style={{ marginTop: 16, marginBottom: 16 }} />
				</div>
			))}
		</Drawer>
	)
}

export default SingleJobFinishDrawer
